<section>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div
            class="modal fade"
            id="selectpg-popup"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body mdltp-txtcont">
                  <h5>New Joinee Workflow</h5>

                  <div *ngIf="customMessage?.isHtml" [innerHTML]="customMessage?.message"></div>
                  <div *ngIf="!customMessage?.isHtml">{{ customMessage?.message }}</div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" (click)="closeModal()">Exit</button>
                  <button type="button" class="btn btn-primary" (click)="goToNewJoineeActivity()">
                    Go to New Joinee Activity
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
